import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { SubcontractorRequestActionTypes } from "./SubcontractorRequest.type";

export function* fetchAllSubcontractorRequests(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/subcontractor-request?project_id=${action.payload?.project_id}`);
    yield put({
      type: SubcontractorRequestActionTypes.FETCH_ALL_SUBCONTRACTOR_REQUEST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: SubcontractorRequestActionTypes.FETCH_ALL_SUBCONTRACTOR_REQUEST_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneSubcontractorRequests(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/subcontractor-request/${action.payload}`
    );
    yield put({
      type: SubcontractorRequestActionTypes.FETCH_ONE_SUBCONTRACTOR_REQUEST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: SubcontractorRequestActionTypes.FETCH_ONE_SUBCONTRACTOR_REQUEST_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllSubcontractorRequests() {
  yield takeLatest(SubcontractorRequestActionTypes.FETCH_ALL_SUBCONTRACTOR_REQUEST, fetchAllSubcontractorRequests);
}

export function* watcherFetchOneSubcontractorRequests() {
  yield takeLatest(SubcontractorRequestActionTypes.FETCH_ONE_SUBCONTRACTOR_REQUEST, fetchOneSubcontractorRequests);
}
